import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchFonts = createAsyncThunk(
    'masters/fetchFonts',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/fonts`);
            return { success: true, message: "Fonts fetched successfully!", data: response?.data?.fonts };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);
export const createFonts = createAsyncThunk(
    'masters/createFonts',
    async (formData) => {
        try {
            const response = await myAxios.post(`/masters/fonts`,formData);
            return { success: true, message: "Fonts added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const updateFonts = createAsyncThunk(
    'masters/updateFonts',
    async (formData) => {
        try {
            const response = await myAxios.put(`/masters/fonts/${formData?.fontId}`, formData);
            return { success: true, message: "Fonts updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteFonts = createAsyncThunk(
    'masters/deleteFonts',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/fonts/${query.fontId}`);
            return { success: true, message: "Fonts deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);



const fontsSlice = createSlice({
    name: 'fonts',
    initialState,
    reducers: {
        clearFontsData: state => {
            state.data = [];
        },
        setFontsData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const fontsReducer = fontsSlice.reducer;
export const { clearFontsData, setFontsData } = fontsSlice.actions;

export const selectFontsData = (state) => state.fonts.data;
